import aiGenerateService from '@services/aiGenerateService.js';

const pluginIds = {
  ai: {
    id: 3,
    name: 'Makewebeasy AI',
  }
}
const state = {
  creditDetail: {
    ai: {
      available: undefined,
      creditUsed: undefined,
      creditRemaining: undefined,
      isSufficient: false,
    },
  },
  isLoading: {
    ai : false
  }
}

const getters = {
  isLoading: state => {
    return state.isLoading;
  },
  isLoadingAiCredit: state => {
    return state.isLoading.ai;
  },
  creditDetail: state => {
    return state.creditDetail;
  },
  creditDetailAI: state => {
    return state.creditDetail.ai;
  },
  
}
const mutations = {
  SET_IS_LOADING(state, { type, isLoading }) {
    state.isLoading[type] = isLoading;
  },
  SET_CREDIT_DETAIL(state, { type, creditDetail }) {
    state.creditDetail[type] = {...state.creditDetail[type], ...creditDetail};
  },
}

const actions = {
  init: ({ dispatch }, { type }) => {
    dispatch('fetchCreditDetail', { type });
  },

  async fetchCreditDetail({ commit, dispatch }, { type }) {
    const plugin = await dispatch('getPluginIds', { type });
    if (!plugin) return;

    dispatch('setIsLoading', { type, isLoading: true });
    const params = { pluginId: plugin.id };

    const response = await aiGenerateService.getCreditAvailable(params);
    const data = (response && response.success && response.data) ? response.data : {};
    console.log(data)

    
    const creditInfo = {
      available: parseFloat(Number(data.available)) || 0,
      creditUsed:  0,
      creditRemaining: 0,
      isSufficient: false,
    };

    commit('SET_CREDIT_DETAIL', { type, creditDetail: creditInfo });
    dispatch('setIsLoading', { type, isLoading: false });
  },
  async postCreditCheck({ commit, dispatch }, { type, promptInput, }) {
    const plugin = await dispatch('getPluginIds', { type });
    if (!plugin) return;

    dispatch('setIsLoading', { type, isLoading: true });
    const payload = { type : promptInput.type, isGenImage: promptInput.isGenImage };
    const response = await aiGenerateService.postCreditCheck(payload);
    console.log('response', response);
    const data = (response && response.success && response.data) ? response.data : {};
    commit('SET_CREDIT_DETAIL', { type, creditDetail: data });
    dispatch('setIsLoading', { type, isLoading: false });
    return data;
  },
  setIsLoading: ({ commit }, { type, isLoading }) => {
    commit('SET_IS_LOADING', { type, isLoading });
  },
  getPluginIds: (state, { type }) => {
    return pluginIds[type] || null;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};